/* eslint-disable max-classes-per-file */

import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IStandardJobTemplateRequest } from '../models/standard-job-template.model';

export class LoadStandardJobTemplates {
  static readonly type = '[Standard Job Template] Load StandardJobTemplates via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllStandardJobTemplates {
  static readonly type = '[Standard Job Template] Load All StandardJobTemplates via Service';
  constructor() {}
}

export class LoadStandardJobTemplateById {
  static readonly type = '[Standard Job Template] Load a single standard job template';
  constructor(public id: string) {}
}

export class LoadStandardJobTemplateVersionById {
  static readonly type = '[Standard Job Template] Load a single standard job template version';
  constructor(public id: string, public versionId: string) {}
}

export class CreateStandardJobTemplate {
  static readonly type = '[Standard Job Template] Create standard job template';
  constructor(public standardJobTemplate: IStandardJobTemplateRequest) {}
}

export class UpdateStandardJobTemplate {
  static readonly type = '[Standard Job Template] Update standard job template';
  constructor(public standardJobTemplate: IStandardJobTemplateRequest) {}
}

export class DeleteStandardJobTemplate {
  static readonly type = '[Standard Job Template] Delete standard job template';
  constructor(public id: string) {}
}
